import React, { useContext, useState } from 'react'
import '../styles/components.css'
import LanguageContext from '../helper/LanguageContext'
import MaterialIcon from './MaterialIcon';
import './CommonHeader.css';


function CommonHeader({ hideTab, value, onChange, searchQuery, onSearch, showPlus, onAddClick, type, unseenExternalProject = 0, unseenInternalProject = 0, unseenArticleExternal = 0, unseenArticleInternal = 0, joinRequestsExternalCount = 0, joinRequestsInternalCount = 0, searchPlaceholder, companySelector, headerBackgroundColor, filterTabs = false, showOversightTab = false, showInternalTab = true, externalTabLabel, showAllTab = false, showExternalTab = true, subTabs = null, subValue, onSubChange }) {
    const { strings, isGerm } = useContext(LanguageContext);
    const externalLabel = externalTabLabel || strings.external_projects
    const internalLabel = strings.internal_project
    const oversightLabel = strings.rooms_oversight || 'Supervision'
    const oversightInfo = strings.rooms_oversight_info || (isGerm
        ? 'Firmen-Admins sehen unter Supervision alle Kjuup-Chatdaten aller Mitarbeiter und verwalten die Schreibrechte in den Chats.'
        : 'In Supervision, company admins can see all Kjuup chat data of all employees and manage writing rights in the chats.')
    // The (i) next to the Supervision tab opens its explanation under the tabs.
    const [oversightInfoOpen, setOversightInfoOpen] = useState(false)
    const allLabel = strings.filter_all || (isGerm ? 'Alle' : 'All')
    // value -1 = every room, unfiltered (rooms filter tabs only)
    const isAll = showAllTab && value === -1
    const isInternal = value === 1
    // value 2 = company-admin oversight (rooms filter tabs only)
    const isOversight = showOversightTab && value === 2
    const isExternal = !isInternal && !isOversight && !isAll
    
    // Ensure all values are numbers (handle undefined, null, NaN, etc.)
    const getNumericValue = (val) => {
      if (val === null || val === undefined || val === '') return 0;
      const num = Number(val);
      if (isNaN(num) || num < 0) return 0;
      return Math.floor(num);
    };
    
    // The same toggle serves two sections: on the project section it counts
    // unread project messages, on the article feed it counts unseen articles.
    // Values come from /badge/count directly (already includes room invitations).
    const isFeedSection = type === 'feed';
    const externalCount = getNumericValue(isFeedSection ? unseenArticleExternal : unseenExternalProject);
    const internalCount = getNumericValue(isFeedSection ? unseenArticleInternal : unseenInternalProject);

    // Each count renders on its own option rather than inside the sliding pill:
    // the pill only ever covers the selected side, so whatever was unread on the
    // other tab stayed invisible until you switched over to it.
    const renderOptionBadge = (count, side) => (
        count > 0 ? (
            <span className={`toggle-option-badge ${side}`}>
                {count > 99 ? '99+' : count}
            </span>
        ) : null
    );
    
    const showCompanySelector = (isInternal || isOversight) && companySelector;
    
    return (
        <div className="common-header" style={{ '--common-header-bg': isFeedSection ? (headerBackgroundColor ?? '#fff') : 'transparent' }}>
            {/* Tabs row */}
            {!hideTab && filterTabs && (
                <div className="lm-filter-tabs-scroll common-header__tabs">
                    {showAllTab ? (
                        <button
                            type="button"
                            className={`kj-tab position-relative${isAll ? ' is-active' : ''}`}
                            onClick={() => onChange(-1)}
                        >
                            {allLabel}
                        </button>
                    ) : null}
                    {showExternalTab ? (
                        <button
                            type="button"
                            className={`kj-tab position-relative${isExternal ? ' is-active' : ''}`}
                            onClick={() => onChange(0)}
                        >
                            {externalLabel}
                            {renderOptionBadge(externalCount, 'external')}
                        </button>
                    ) : null}
                    {showInternalTab ? (
                        <button
                            type="button"
                            className={`kj-tab position-relative${isInternal ? ' is-active' : ''}`}
                            onClick={() => onChange(1)}
                        >
                            {internalLabel}
                            {renderOptionBadge(internalCount, 'internal')}
                        </button>
                    ) : null}
                    {showOversightTab ? (
                        <button
                            type="button"
                            className={`kj-tab position-relative common-header__tab--late${isOversight ? ' is-active' : ''}`}
                            onClick={() => onChange(2)}
                        >
                            {oversightLabel}
                        </button>
                    ) : null}
                    {showOversightTab ? (
                        <button
                            type="button"
                            className={`kj-tab common-header__info common-header__tab--late${oversightInfoOpen ? ' is-active' : ''}`}
                            aria-label={oversightInfo}
                            aria-expanded={oversightInfoOpen}
                            title={oversightInfo}
                            onClick={() => setOversightInfoOpen((open) => !open)}
                        >
                            <MaterialIcon icon="info" size={18} weight={400} color="currentColor" />
                        </button>
                    ) : null}
                </div>
            )}
            {!hideTab && filterTabs && showOversightTab && oversightInfoOpen ? (
                <div className="common-header__info-note" role="note">
                    <MaterialIcon icon="info" size={16} color="var(--kjuup-accent)" />
                    <span>{oversightInfo}</span>
                </div>
            ) : null}
            {/* Second level under a tab: a segmented control ({ key, label, count }), as on Dateien. */}
            {subTabs && subTabs.length ? (
                <div className="common-header__subtabs">
                  <div className="kj-segmented" role="tablist">
                    {subTabs.map((tab) => (
                        <button
                            key={tab.key}
                            type="button"
                            role="tab"
                            aria-selected={subValue === tab.key}
                            className={`kj-segment${subValue === tab.key ? ' is-active' : ''}`}
                            onClick={() => onSubChange(tab.key)}
                        >
                            {tab.label}
                            {getNumericValue(tab.count) > 0 ? (
                                <span className="common-header__subtab-count">
                                    {tab.count > 99 ? '99+' : getNumericValue(tab.count)}
                                </span>
                            ) : null}
                        </button>
                    ))}
                  </div>
                </div>
            ) : null}
            {!hideTab && !filterTabs && (
                <div className='maindiv common-header__toggle-row'>
                    <div className='toggle-switch-container'>
                        <div 
                            className={`toggle-switch-pill ${isInternal ? 'internal-active' : 'external-active'}`}
                        >
                            <div 
                                className={`toggle-switch-slider common-header__slider ${isInternal ? 'slide-right' : 'slide-left'}`}
                            />
                            <button 
                                className={`toggle-switch-option common-header__option ${!isInternal ? 'active' : ''}`}
                                onClick={() => onChange(0)}
                            >
                                {externalLabel}
                                {renderOptionBadge(externalCount, 'external')}
                            </button>
                            <button 
                                className={`toggle-switch-option common-header__option ${isInternal ? 'active' : ''}`}
                                onClick={() => onChange(1)}
                            >
                                {internalLabel}
                                {renderOptionBadge(internalCount, 'internal')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Search row */}
            <div className="common-header__search-row">
                <div className="searchbar-container common-header__search">
                    <span className="searchbar-icon">
                        <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9" cy="9" r="7" stroke="#B0B0B0" strokeWidth="2"></circle>
                            <line x1="14.2929" y1="14.7071" x2="18" y2="18.4142" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round"></line>
                        </svg>
                    </span>
                    <input
                        className="searchbar-input"
                        type="text"
                        autoComplete="off"
                        value={searchQuery}
                        placeholder={searchPlaceholder || strings.search}
                        onChange={(e) => onSearch(e.target.value)}
                    />
                </div>
                {showPlus ? (
                    <div onClick={() => onAddClick()} className='circle_icon_div common-header__add'>
                        <MaterialIcon 
                            icon="add_circle"
                            size={24}
                            color={isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)'}
                            fill={1}
                            weight={400}
                            className="add-circle-icon"
                        />
                    </div>
                ) : null}
            </div>
            {/* Company selector row - shown below the search on the internal and oversight tabs */}
            {showCompanySelector && (
                <div className="common-header__company-row">
                    {companySelector}
                </div>
            )}
        </div>
    )
}

export default CommonHeader